import {styled} from '@linaria/react';
import React from 'react';
import {useGetAriaLabelFromUrl} from '../../../hooks/useGetAriaLabelFromUrl/useGetAriaLabelFromUrl';
import {ImageType} from '../../../types/Image';
import {UnstyledLinkLinaria} from '../../atoms/UnstyledLink/UnstyledLinkLinaria';
import {FullWidthImage} from '../../molecules/FullWidthImage/FullWidthImage';

interface CardInterface {
  ['data-testid']: string;
  className?: string;
  isCloseToViewport: boolean;
  image: ImageType;
  onClick?: VoidFunction;
  href?: string;
}

export const Card: React.FC<React.PropsWithChildren<CardInterface>> = ({
  'data-testid': dataTestId,
  className,
  isCloseToViewport,
  image,
  onClick,
  children,
  href,
}) => {
  const getAriaLabelFromUrl = useGetAriaLabelFromUrl();

  return (
    <CardContainer
      data-testid={dataTestId}
      className={className}
      onClick={onClick}
    >
      <StyledFullWidthImage
        dataTestId="browseCardImage"
        imageUrl={image.url}
        description={image.description}
        aspectRatio="2:1"
        highPrioImage={isCloseToViewport}
        disableFixedRatio
        imagePosition="top"
      />
      {href && (
        <BannerTarget
          to={href}
          data-testid="bannerTarget"
          aria-label={getAriaLabelFromUrl(href)}
        />
      )}
      {children}
    </CardContainer>
  );
};

const CardContainer = styled.div`
  height: 100%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.02) 0%,
      rgba(0, 0, 0, 0.04) 50%,
      rgba(0, 0, 0, 0.2) 60%,
      rgba(0, 0, 0, 0.4) 100%
    );
  }
`;

const StyledFullWidthImage = styled(FullWidthImage)`
  height: 100%;
`;

export const ContentContainer = styled.div`
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 1;
  pointer-events: none;
`;

const BannerTarget = styled(UnstyledLinkLinaria)`
  position: absolute;
  inset: 0;
  z-index: 1;
`;
